/**
 * Wyświetla listę notatek
 */

import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import EditNoteIcon from '@material-ui/icons/Description';
import { connect } from 'react-redux';

import { getNotes, deleteNote, addRecentNote } from '../../redux/actions';
import ActionMenu from './ActionMenu';
import Note from './Note';
import useStyles from './index.styles';

function Notes (props) {
  const classes = useStyles();
  const { notes, deleteNote } = props;
  const [ note, setNote ] = useState({ open: false, title: '', content: '' });

  useEffect(() => {
    if (props.notes.length === 0) props.getNotes();
    // eslint-disable-next-line
  }, []);

  const showNote = ({ id, title, content }) => {
    props.addRecentNote(id);
    setNote({ id, open: true, title, content })
  }

  const hideCard = () => {
    setNote({ open: false });
  }

  const newNote = () => {
    setNote({id: false, title: '', content: '', open: true });
  }

  const getCard = ({ id, title, excerpt, content }) => {
    return (
      <Paper 
        key={title + id} 
        elevation={1} 
        className={classes.paper} 
        onClick={() => showNote({ id, title, content })}
      >
        <h4><EditNoteIcon /> <span>{title}</span></h4>
        <p>{excerpt} &nbsp;</p>
        <ActionMenu 
          note={{ id, title, content }}
          showNote={showNote}
          deleteNote={deleteNote}
        />
      </Paper>
    )
  }

  return (
    <>
      {notes.length === 0 && <div style={{marginBottom: '1em'}}>
        Obecnie nie masz żadnych notatek. Utwórz nową notatkę klikając na przycisk "DODAJ NOWĄ"
      </div>}
      <div className={classes.action}>
        <Button color="primary" className={classes.button} onClick={newNote}><AddIcon /> Dodaj</Button>
      </div>
      <div className={classes.wrap}>
        {notes.map(getCard)}
      </div>
      {note.open && <Note note={note} hide={hideCard}/>}
    </>
  );
}

const mapStateToProps = state => {
  return { 
    notes: state.notes,
  };
}

export default connect(mapStateToProps, { getNotes, deleteNote, addRecentNote })(Notes);